import Button from "components/base/Button";
import { Alert } from "components/base/Toast";
import { useEffect, useState } from "react";
import { BsArrowDownCircle } from "react-icons/bs";
import {
  IoIosCheckmarkCircle,
  IoIosCheckmarkCircleOutline,
} from "react-icons/io";
import { download } from "utils/http";

const BomExportForm = ({ hide, shipment }) => {
  const [selectedRowIds, setSelectedRowIds] = useState([]);
  const [exporting, setExporting] = useState(false);

  useEffect(() => {
    if (shipment.shipmentInvoices) {
      setSelectedRowIds(
        shipment.shipmentInvoices
          .flatMap((i) => i.shipmentInvoiceRows)
          .map((i) => i.id),
      );
    }
  }, [shipment.shipmentInvoices]);

  function onClickHandler() {
    setExporting(true);
    download(
      `/shipment/${shipment.id}/bom/xlsx/`,
      `BOM-SO${shipment.invoiceNumber}.xlsx`,
      {
        shipment_invoice_row_ids: selectedRowIds,
      },
    )
      .then(() => {
        if (hide) hide();
      })
      .catch((err) => {
        Alert("error", String(err));
      })
      .finally(() => {
        setExporting(false);
      });
  }

  return (
    <div>
      <div>Select Products to Generate BOM file.</div>
      <div className="mt-4 space-y-6">
        {shipment.shipmentInvoices.map((shipmentInvoice) => (
          <div key={shipmentInvoice.id} className="card px-6 py-4">
            <h4>SO{shipmentInvoice.invoice.number}</h4>
            <div className="mt-2">
              {shipmentInvoice.shipmentInvoiceRows.map((row) => (
                <div
                  key={row.id}
                  className={`p-2 border-b flex items-center space-x-4 cursor-pointer hover:text-green-600
                  ${selectedRowIds.includes(row.id) ? "text-green-500 active:text-gray-700" : "text-gray-700 active:text-green-700"}`}
                  onClick={() =>
                    setSelectedRowIds((prev) =>
                      selectedRowIds.includes(row.id)
                        ? prev.filter((i) => i !== row.id)
                        : [...prev, row.id],
                    )
                  }
                >
                  <div className="flex-shrink-0">
                    {selectedRowIds.includes(row.id) ? (
                      <IoIosCheckmarkCircle size={21} />
                    ) : (
                      <IoIosCheckmarkCircleOutline size={21} />
                    )}
                  </div>
                  <div className="flex justify-between flex-1">
                    <div>
                      [{row.itemNumber}] {row.productName}
                    </div>
                    <div>{row.qty}</div>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-4">
              <Button
                onClick={() => {
                  const rowIds = shipmentInvoice.shipmentInvoiceRows.map(
                    (row) => row.id,
                  );
                  setSelectedRowIds((prev) =>
                    rowIds.every((id) => prev.includes(id))
                      ? prev.filter((id) => !rowIds.includes(id))
                      : [...new Set([...prev, ...rowIds])],
                  );
                }}
              >
                Toggle Select
              </Button>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 text-base flex justify-end">
        <Button
          loading={exporting}
          onClick={onClickHandler}
          icon={<BsArrowDownCircle />}
        >
          Generate
        </Button>
      </div>
    </div>
  );
};

export default BomExportForm;
